// Merchant Service - GraphQL operations for Merchant role
import { graphqlClient } from '../graphqlClient';

// ==================== Profile ====================

export const getProfile = async () => {
  const query = `
    query GetMerchantProfile {
      merchantProfile {
        id
        email
        name
        contactName
        contactEmail
        contactPhone
        status
        code
        balance
        depositFee
        withdrawalFee
        percentageFee
        parentName
        parentType
        parentDepositFee
        parentWithdrawalFee
        callbackUrl
        webhookUrl
        apiKey
        secretKey
        createdAt
        updatedAt
      }
    }
  `;

  const result = await graphqlClient.query(query);
  return result.merchantProfile;
};

export const updateProfile = async (input) => {
  const mutation = `
    mutation MerchantUpdateProfile($input: MerchantUpdateProfileInput!) {
      merchantUpdateProfile(input: $input) {
        id
        email
        name
        status
        createdAt
        updatedAt
      }
    }
  `;

  const result = await graphqlClient.mutate(mutation, { input });
  return result.merchantUpdateProfile;
};

// ==================== Withdrawals ====================

export const getMerchantWithdrawals = async () => {
  const query = `
    query MerchantWithdrawals {
      merchantWithdrawals {
        id
        merchant_id
        amount
        bank_code
        bank_account
        account_name
        bank_name
        network
        wallet_address
        status
        createdAt
        updatedAt
        merchants {
          id
          name
          email
        }
      }
    }
  `;
  const result = await graphqlClient.query(query);
  return result.merchantWithdrawals;
};

export const createMerchantWithdrawal = async (input) => {
  const mutation = `
    mutation CreateWithdrawal($input: CreateWithdrawalInput!) {
      createWithdrawal(input: $input) {
        id
        merchant_id
        amount
        bank_code
        bank_account
        account_name
        bank_name
        network
        wallet_address
        status
        createdAt
        updatedAt
      }
    }
  `;

  const result = await graphqlClient.mutate(mutation, { input });
  return result.createWithdrawal;
};

// ==================== Dashboard Stats ====================

export const getDashboardStats = async () => {
  const query = `
    query GetMerchantDashboardStats {
      merchantDashboardStats {
        totalTransactions
        totalDeposits
        totalWithdrawals
        successfulTransactions
        failedTransactions
      }
    }
  `;

  const result = await graphqlClient.query(query);
  return result.merchantDashboardStats;
};





